var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FF6C3E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1993_39215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 14.2031L12.2937 18.9074C12.2937 18.914 12.292 18.9238 12.2887 18.9371C12.2854 18.9503 12.2837 18.9599 12.2837 18.9667V23.7303C12.2837 23.9023 12.3466 24.0513 12.4723 24.1769C12.598 24.3024 12.7468 24.3656 12.9189 24.3656H16.7296V20.5547H19.2705V24.3658H23.0812C23.2532 24.3658 23.4023 24.3027 23.5278 24.1769C23.6535 24.0515 23.7166 23.9023 23.7166 23.7303V18.9667C23.7166 18.9403 23.713 18.9204 23.7066 18.9074L18 14.2031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8897 17.8356L23.7164 16.0293V11.9802C23.7164 11.8877 23.6866 11.8115 23.6269 11.752C23.5677 11.6925 23.4916 11.6627 23.3988 11.6627H21.4934C21.4007 11.6627 21.3246 11.6925 21.265 11.752C21.2055 11.8115 21.1758 11.8877 21.1758 11.9802V13.9154L18.7543 11.8908C18.5429 11.7188 18.2914 11.6328 18.0002 11.6328C17.7091 11.6328 17.4577 11.7188 17.246 11.8908L10.1103 17.8356C10.0441 17.8884 10.0079 17.9595 10.0011 18.0488C9.99442 18.1381 10.0175 18.2161 10.0705 18.2822L10.6858 19.0166C10.7388 19.0761 10.8082 19.1125 10.8943 19.1258C10.9737 19.1325 11.0531 19.1093 11.1325 19.0564L18 13.3299L24.8676 19.0563C24.9206 19.1025 24.99 19.1255 25.076 19.1255H25.1058C25.1917 19.1125 25.261 19.0758 25.3143 19.0165L25.9296 18.2822C25.9825 18.2159 26.0057 18.1381 25.9988 18.0487C25.9921 17.9596 25.9557 17.8885 25.8897 17.8356Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1993_39215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.ce2601ca22d318acae074ce6acaddb49.svg";
export { ForwardRef as ReactComponent };